// extracted by mini-css-extract-plugin
export default {"button":"Button_button__QOtX3","borderedButton":"Button_borderedButton__slvZN","small":"Button_small__LbREd","secondaryBtn":"Button_secondaryBtn__J8vM6"};